import { render, staticRenderFns } from "./assistanceMoneyDetail.vue?vue&type=template&id=20cb16c9&scoped=true"
import script from "./assistanceMoneyDetail.vue?vue&type=script&lang=js"
export * from "./assistanceMoneyDetail.vue?vue&type=script&lang=js"
import style0 from "./assistanceMoneyDetail.vue?vue&type=style&index=0&id=20cb16c9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20cb16c9",
  null
  
)

export default component.exports